import Switch from '@mui/material/Switch';
import MIKE_COLORS from '../../styles/mike-colors';
import { styled } from '@mui/material';

export const MikeSwitch  = styled(Switch)(({theme}) => ({ 
  width: 36,
  height: 14,
  padding: 0,
  display: 'inline-flex',
  overflow: 'inherit',
  float: 'right', 
  '& .MuiSwitch-switchBase': {
    padding: 4,
    color: MIKE_COLORS.DARKGREY_DEFAULT,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: MIKE_COLORS.GREEN_DARK,   
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: MIKE_COLORS.GREEN_LIGHT,
        borderColor: MIKE_COLORS.GREEN_LIGHT
      },  
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },    
  },
  '& .MuiSwitch-thumb': {
    width: 10,
    height: 10,
    boxShadow: 'none',
  },
  '& .MuiSwitch-track': {
    border: `2px solid ${MIKE_COLORS.DARKGREY_DEFAULT}`,
    borderRadius: 20 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}));


